package repositories

import practicetest.TopicListResponse

class TopicRepositoryException(val isNetwork: Boolean) : Exception()

interface TopicRepository {
    suspend fun fetchTopics(forSubject: String): Result<TopicListResponse>
}